import { SvgConsumer } from '@components/icons/svgConsumer';
import { Button } from '@components/ui/button';
import { cn } from '@utils/cn';
import { useState } from 'react';
import { DrawerSectionProps } from './types';

export const DrawerSection = ({
  children,
  title,
  titleObject,
  titleBadge,
  headerRight,
  description,
  alwaysOpen = false,
  defaultExpanded = false,
  expanded: expandedProp,
  onExpandedChange,
  disabled,
  className = '',
  titleClassName = '',
}: DrawerSectionProps) => {
  const [uncontrolledExpanded, setUncontrolledExpanded] = useState(alwaysOpen || defaultExpanded);
  const controlled = expandedProp !== undefined;
  const expanded = alwaysOpen ? true : controlled ? expandedProp! : uncontrolledExpanded;

  const setExpanded = (next: boolean) => {
    if (!alwaysOpen && !controlled) setUncontrolledExpanded(next);
    onExpandedChange?.(next);
  };

  return (
    <div
      className={cn(
        'flex flex-col gap-1 border-t p-2',
        disabled && 'opacity-50 bg-neutral-50 pointer-events-none',
        className,
      )}>
      <div
        className={cn(
          'flex shrink-0 items-center justify-between',
          !alwaysOpen && !titleObject && 'cursor-pointer',
        )}
        onClick={() => {
          if (alwaysOpen) return;
          if (titleObject) return;
          setExpanded(!expanded);
        }}>
        <span className="flex items-center gap-1">
          {title && (
            <span className="flex items-center gap-1">
              <strong className={cn('font-bold', titleClassName)}>{title}</strong>
              {titleBadge}
            </span>
          )}
          {titleObject}
        </span>
        <span
          className="flex items-center gap-1"
          onClick={(e) => headerRight && e.stopPropagation()}>
          {headerRight}
          {!alwaysOpen && (
            <Button
              variant="ghost"
              className={cn(
                'h-fit gap-2 px-0 py-2 text-neutral-400 hover:bg-transparent hover:text-neutral-700',
                !!titleObject && 'grow cursor-pointer',
              )}
              onClick={(e) => {
                e.stopPropagation();
                setExpanded(!expanded);
              }}>
              <SvgConsumer
                id="expand"
                className={cn('shrink-0 text-xs ml-auto', !expanded && 'rotate-180')}
              />
            </Button>
          )}
        </span>
      </div>
      {description && <p className="text-xs text-neutral-400">{description}</p>}
      {expanded && children}
    </div>
  );
};
